/* eslint-disable import/prefer-default-export */

import { makeEntityScaffold } from '@classpass/saga-tools';

export const plansByMsa = makeEntityScaffold(
  'SAGA.API.PLANS',
  (client, msaId, options = {}) => client.plans.getByMsaV3(msaId, options).then(data => data.plans),
  { defaultKey: 1 }
);

export const planById = makeEntityScaffold(
  'SAGA.API.PLAN_BY_ID',
  (client, planId, options = {}) => client.plans.getByIdV2(planId, options),
  { defaultKey: 1 }
);

export const saveOffer = makeEntityScaffold('SAGA.API.SAVE_OFFER', (client, userId) =>
  client.plans.getUserSaveOffer(userId)
);
